import styled from 'styled-components';

export const StepperContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    max-width: 525px;
    margin: 0 auto;
    font-weight: ${props => props.theme.boldWeight};

    &.mobileDisplay {
        display: none;
    }

    .step-layout {
        display: flex;

        &.step-layout-flex {
            flex: 1;
        }

        .line-container {
            display: flex;
            height: 20px;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            margin-left: -35px;
            margin-right: -35px;

            .line-style {
                width: 100%;
                height: 1px;
            }
        }

        .step-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            .circle {
                height: 20px;
                width: 20px;
                border-radius: 20px;
                align-items: center;
                justify-content: center;
                display: flex;
            }

            .check-icon svg path {
                fill: ${props => props.theme.white};
            }
        }

        p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 90px;
        }

        .label-inactive {
            color: ${props => props.theme.inactive};
        }

        .label-active {
            color: ${props => props.theme.primary};
        }

        .step-inactive {
            background-color: ${props => props.theme.inactive};
        }

        .step-active {
            background-color: ${props => props.theme.primary};
        }
    }

    @media (max-width: ${props => props.theme.mobile}) {
        display: none;
        margin: 25px auto;

        &.mobileDisplay {
            display: flex;
        }

        .step-container {
            font-size: 12px;

            .check-icon svg {
                height: 10px;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/StepperStyle.js